import { useNavigate, useLocation } from 'react-router-dom';

import { Spacing, Button } from '~ui-kit';
import { getFormCustomContentByFormType } from '~utils/common.utils';

const ActionButtons = ({ task }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      {task.returnable && task.observer && (
        <Button
          secondary
          onClick={() =>
            navigate(
              `/palvelut/${getFormCustomContentByFormType(
                task.formType
              )}/paluukuljetus/${task.id}`
            )
          }
        >
          Tilaa paluukuljetus
        </Button>
      )}
      <Spacing horizontal small />
      {task.observer &&
        task.formType !== 'CUSTOM_FORM_INTERNALPACKETTRANSPORT' && (
          <Button
            secondary
            onClick={() =>
              navigate(`/tilaukset/${task.id}/valmis`, {
                state: { previousLocation: location },
              })
            }
          >
            Merkitse valmiiksi
          </Button>
        )}
    </div>
  );
};

export default ActionButtons;
